<template>
 <!-- <v-container fluid> -->
  <v-layout column class="info-width">
    <!-- MESSAGES -->
    <v-dialog
      v-model="showMessage"
      max-width="390"
      persistent
    >
      <v-card width="390">
        <v-card-title primary-title>
          <div>
            <div class="headline">{{ messageToShow }}</div>
            <span>
              Ésta alarma ha sido justificada por otro usuario.
            </span>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="closeMessage"
          >
            <v-icon left>clear</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- JUSTIFICATION COMPONENT -->
    <v-dialog
      v-model="showJustification"
      max-width="390"
      persistent
    >
      <justification-alert
        :alarm='alarmSelected'
        @showDialog='showJustification = false'
        @showMessage='showMessageIn'
      />
    </v-dialog>
    <!-- INFO ALARMS -->
    <v-flex d-inline-flex align-center class="general-info-container" pa-3 mb-1>
      <v-flex style="max-width: 250px; min-width: 250px;">
        <h2>Excesos de Velocidad</h2>
      </v-flex>
      <v-flex
        v-if="!loadingSpeedAlarms"
        style="max-width: 190px; min-width: 190px;"
      >
        <h3 class="pl-2"><span class="body-2">Total Alarmas:</span> {{ speedsAlarms.length }}</h3>
      </v-flex>
    </v-flex>
    <!-- HEADER -->
    <v-flex d-flex py-1 mb-1 class="text-xs-left header-container">
      <v-flex class="text-xs-left info-vehicle" pl-4>Quien</v-flex>
      <v-flex pl-2 offset-xs1>Que</v-flex>
      <v-flex pl-5 offset-xs1>Desde</v-flex>
      <v-flex pl-5 offset-xs1>Hasta</v-flex>
      <v-flex pl-5 ml-3>Eventos</v-flex>
      <v-flex >Justificación</v-flex>
    </v-flex>
    <!-- LOADING -->
    <v-flex v-if="loadingSpeedAlarms" pa-5>
      <v-progress-circular indeterminate color="white"></v-progress-circular>
      Cargando datos...
    </v-flex>
    <!-- CONTENT -->
    <v-flex v-else>
      <!-- ALARM DATA -->
      <v-flex v-if="speedsAlarms.length > 0">
        <v-expansion-panel focusable>
          <v-expansion-panel-content
            v-for="alarm in speedsAlarms"
            :key="alarm.device">
            <!-- HEADER -->
            <template v-slot:header>
              <v-flex d-flex class="text-xs-left" align-center>
                <v-flex class="info-vehicle">
                  <v-flex>
                    <v-flex class="small-text">Código/Sigla</v-flex>
                    <v-flex><b>{{ vehicleCode(alarm.device) }}</b></v-flex>
                  </v-flex>
                  <v-flex pt-1>
                    <v-flex class="small-text">Placa</v-flex>
                    <v-flex><b>{{ vehiclePlate(alarm.device) }}</b></v-flex>
                  </v-flex>
                </v-flex>
                <v-flex>Exceso de Velocidad</v-flex>
                <v-flex>{{ alarm.speeds[0].time | filterFullDate }}</v-flex>
                <v-flex>{{ alarm.speeds[alarm.speeds.length -1].time | filterFullDate }}</v-flex>
                <v-flex class="events-text">{{ alarm.speeds.length }}</v-flex>
                <v-flex class="justification-style">
                  <!-- NULL -->
                  <v-flex
                    v-if="alarm.justification.isJustified === null"
                    :class="alarm.justification.userInProgressRemote ? 'in-progress-state' : ''"
                    d-inline-flex
                    align-center
                  >
                    <v-btn
                      fab
                      small
                      flat
                      :disabled="alarm.justification.justificationInProgress"
                      @click.stop="justifyAlert({
                        alarmId: alarm.alarmId,
                        vehicleId:alarm.vehicleId,
                        justification: alarm.justification,
                        licensePlate: vehiclePlate(alarm.device),
                        code: vehicleCode(alarm.device)
                      })"
                    >
                      <v-icon
                        v-if="alarm.justification.userInProgressRemote"
                        color="grey lighten-1"
                      >
                        textsms
                      </v-icon>
                      <v-icon
                        v-else
                        color="grey lighten-1"
                      >
                        chat_bubble
                      </v-icon>
                    </v-btn>
                    <!-- USER IN PROGRESS -->
                    <v-tooltip
                      left
                      color="amber lighten-2 grey--text text--darken-3"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="alarm.justification.userInProgressRemote"
                          class="hover-icon"
                          style="margin-left:-15px"
                          color="amber"
                          v-on="on"
                        >
                          record_voice_over
                        </v-icon>
                      </template>
                      <span style="color:#424242">
                        ...justificando
                        <br />
                          <b>{{ alarm.justification.userInProgressRemote }}</b>
                      </span>
                    </v-tooltip>
                  </v-flex>
                  <!-- FALSE -->
                  <v-btn
                    v-else-if="alarm.justification.isJustified === false"
                    fab
                    small
                    flat
                    @click.stop="justifyAlert({
                      alarmId: alarm.alarmId,
                      vehicleId:alarm.vehicleId,
                      justification: alarm.justification,
                      licensePlate: vehiclePlate(alarm.device),
                      code: vehicleCode(alarm.device)
                    })"
                  >
                    <v-icon color="error">report_off</v-icon>
                  </v-btn>
                  <!-- TRUE -->
                  <v-btn
                    v-else-if="alarm.justification.isJustified === true"
                    fab
                    small
                    flat
                    @click.stop="justifyAlert({
                      alarmId: alarm.alarmId,
                      vehicleId:alarm.vehicleId,
                      justification: alarm.justification,
                      licensePlate: vehiclePlate(alarm.device),
                      code: vehicleCode(alarm.device)
                    })"
                  >
                    <v-icon color="success">message</v-icon>
                  </v-btn>
                </v-flex>
              </v-flex>
            </template>
            <!-- CONTENT -->
            <v-card class="pt-3" color="grey darken-4">
              <v-card-text>
                <v-flex d-inline-flex pl-5>
                  <v-flex class="text-xs-center">
                    <router-link :to="`/vehicles/${vehicleId(alarm.device)}`">
                      <VAvatar
                        size="50"
                        color="grey">
                        <v-icon dark large>directions_car</v-icon>
                      </VAvatar>
                      <br>
                      Ver Vehículo
                    </router-link>
                    <v-flex>
                      <v-flex class="small-text">Código/Sigla</v-flex>
                      <v-flex><b>{{ vehicleCode(alarm.device) }}</b></v-flex>
                      <v-flex class="small-text">Placa</v-flex>
                      <v-flex><b>{{ alarm.plate }}</b></v-flex>
                      <v-flex class="small-text">Agencia</v-flex>
                      <v-flex><b>{{ getAgencyId(alarm.device) | agencyName }}</b></v-flex>
                    </v-flex>
                  </v-flex>
                  <v-flex>
                    <v-flex class="body-2 grey--text" d-inline-flex pl-5>
                      <v-flex>
                        <b>Velocidad</b>
                      </v-flex>
                      <v-flex pl-5>
                        <b>Fecha y Hora</b>
                      </v-flex>
                    </v-flex>
                    <v-flex
                      v-for="(speed, index) in alarm.speeds"
                      :key="index"
                      pl-5>
                      <v-flex
                        d-inline-flex
                        align-center
                        :class="[index % 2 ? '' : rowbg]"
                        class="info-vehicle-in caption"
                        px-2
                        py-1
                      >
                        <v-flex>
                          {{ `${speed.speed} Km/h`}}
                        </v-flex>
                        <v-flex pl-5>
                          {{ speed.time | filterFullDate }}
                        </v-flex>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <!-- MESSAGE -->
      <v-flex v-else px-3 py-3>
        <h2>En éste momento no hay alarmas por exceso de velocidad.</h2>
        <p>A medida que se generen nuevas alarmas, éstas se cargaran automáticamente.</p>
      </v-flex>      
    </v-flex>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  // import * as types from '../store/mutations-types'

  import JustificationAlert from '../components/JustificationAlert'

  export default {
    name: 'speed-alerts',
    components: {
      JustificationAlert
    },
    data() {
      return {
        // intervalActive: false,
        intervalSpeedAlarmsValue: 20000,
        intervalSpeedAlarmsInstance: null,
        showJustification: false,
        alarmSelected: {},
        rowbg: 'bg-row',
        showMessage: false,
        messageToShow: ''
      }
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole',
        user: 'auth/getProfile'
      }),
      ...mapGetters([
        'pusherRef',
        'vehiclePlate',
        'speedsAlarms',
        'vehicleId',
        'vehicleCode',
        'loadingSpeedAlarms',
        'getAgencyId'
      ])
    },
    methods: {
      ...mapActions(['clearSpeedsAlarms', 'setLoadingSpeedAlarms', 'fetchSpeedAlarms']),
      intervalForSpeedAlarms() {
        // this.intervalActive = true
        this.intervalSpeedAlarmsInstance = setInterval(() => {
          // const value = this.page
          this.fetchSpeedAlarms()
        }, this.intervalSpeedAlarmsValue)
        // console.log('intervalForSpeedAlarms', this.intervalSpeedAlarmsInstance)
      },
      justifyAlert(alarm) {
        if (alarm.justification.isJustified === null) {
          // console.log('CHANNELS', this.pusherRef)
          const channel = this.pusherRef.channels.channels['presence-justification-in-progress']
          // console.log('CHANNEL', channel)
          channel.trigger(
            'client-justification-in-progress',
            {
              i: alarm.alarmId,
              vi: alarm.vehicleId,
              t: 'speed',
              v: true,
              u: this.user.name
            }
          )
        }

        // console.log('ALARM', alarm)
        const type = 'speed'
        this.alarmSelected = {
          ...alarm.justification,
          vehicleId: alarm.vehicleId,
          alarmId: alarm.alarmId,
          licensePlate: alarm.licensePlate,
          code: alarm.code,
          type
        }
        // console.log('alarmSelected', this.alarmSelected)
        this.showJustification = true
      },
      showMessageIn(data) {
        this.messageToShow = data.message
        this.showMessage = true
      },
      closeMessage() {
        this.messageToShow = ''
        this.showMessage = false
      }
    },
    mounted() {
      // this.initializeAlerts()
      // console.log('MOUNTED SPEED ALERTS')
      this.setLoadingSpeedAlarms(true)
      this.fetchSpeedAlarms()
      this.intervalForSpeedAlarms()
    },
    beforeDestroy() {
      // console.log('BEFORE DESTROY SPEED ALERTS: ', this.intervalSpeedAlarmsInstance)
      clearInterval(this.intervalSpeedAlarmsInstance)
      // this.intervalActive = false
      this.clearSpeedsAlarms()
    }
  }
</script>

<style lang="stylus" scoped>
span
  color #BDBDBD

a
  text-decoration none
  color white
  font-size 16px

a:hover
  opacity 0.7

.justification-style
  min-width 80px
  max-width 80px
  text-align left

.bg-row
  background-color rgba(255, 255, 255, 0.07)
  border-radius 2px

.events-text
  font-size 18px
  font-weight 500

.info-vehicle
  width 120px

.small-text
  font-size 8px

.general-info-container
  height 70px
  border-radius 3px
  background-color #424242

.header-container
  height 35px
  border-radius 3px
  background-color #424242
  font-size 16px
  font-weight 500

.info-width
  min-width 960px
  max-width 1024px

.info-vehicle-in
  height 24px

.hover-icon:hover
  cursor: pointer

.in-progress-state
  border dashed 1px #FFD54F
  border-radius 10px
  max-width 85px
  min-width 85px
  max-height 50px
  min-height 50px
  margin-left -15px
  padding-right 15px
</style>



// WEBPACK FOOTER //
// src/components/SpeedAlerts.vue